import { render, staticRenderFns } from "./SeparatorGradient.vue?vue&type=template&id=3181d32f&scoped=true&"
var script = {}
import style0 from "./SeparatorGradient.vue?vue&type=style&index=0&id=3181d32f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3181d32f",
  null
  
)

export default component.exports